import styled from 'styled-components'
import { WIDE_SCREEN } from 'constants/breakpoints'

export const FieldLine = styled.div`
  text-align: left;
  margin: 1rem 0;
  word-break: break-word;
  @media only screen and (min-width: ${WIDE_SCREEN}) {
    font-size: 22px;
    margin: 1.25rem 0;
  }
`
